import styled from "styled-components";

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MappingCard = styled.div<{ collapsed?: boolean }>`
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: ${({ collapsed }) => (collapsed ? "12px 16px" : "16px")};
  position: relative;
`;

export const MappingCardField = styled.div`
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const MappingCardCollapsed = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;

  &:hover {
    background-color: #f8fafc;
    margin: -16px;
    padding: 16px;
    border-radius: 8px;
  }
`;

export const MappingCardSummary = styled.span`
  font-size: 14px;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

export const CardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  font-size: 16px;
  padding: 4px;
  line-height: 1;

  &:hover {
    color: #1d9bf0;
  }

  &.danger:hover {
    color: #ef4444;
  }
`;

export const MappingIndex = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
  margin-bottom: 8px;
  display: block;
`;

export const EmptyState = styled.div`
  padding: 24px 16px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  color: #64748b;
  font-size: 13px;
  text-align: center;
`;

export const FooterField = styled.div`
  margin-bottom: 0;
`;
